module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-mov-9.d926159e.png";